<template>
  <div class="category-sitemap">
    <CategorySitemapMainCategory
      v-for="category in sitemapData"
      :key="category.productCategory.name"
      :category="category"
    />
  </div>
</template>

<script>
import CategorySitemapMainCategory from '@/components/category-sitemap-main-category.vue';

export default {
  name: 'CategorySitemap',
  components: {
    CategorySitemapMainCategory,
  },
  props: {
    sitemapData: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.category-sitemap {
  display: grid;
  grid-template-columns: 1fr;
  @include mq($mq-md) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
  }
  @include ie-only() {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    > div {
      flex-basis: 30%;
      width: 30%;
    }
  }
}
</style>
